import InfoTooltip from "../../FormControls/InfoTooltip/InfoTooltip";
import React, { ReactElement } from "react";
import SizeTable from "./SizeTable";
import { sizeCustomFieldKeys } from "./SizeTable";

export type sizeField = typeof sizeCustomFieldKeys[number];

export default function SizeGuide({
  categoryName,
  field,
  icon,
}: {
  categoryName: string;
  field: sizeField;
  icon?: ReactElement;
}) {
  if (!sizeCustomFieldKeys.includes(field)) return null;

  return (
    <InfoTooltip
      title={<SizeTable categoryName={categoryName} field={field} />}
      displayTime={60000}
      icon={icon}
    />
  );
}
